import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { IdentityService } from 'main/services/identity.service'

@Component({
  selector: 'empty-state',
  templateUrl: './emptyState.component.pug',
  styleUrls: ['./emptyState.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  @Input() icon: string|null
  @Input() text: string|null
  @Input() hint: string|null
  @Input() hintPermission: string|null

  constructor (public identity: IdentityService) { }
}
